import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { store } from '../stores/mainStore';
import { history } from '../history';

const BlurPage = styled.div`
	/* margin-top: 35%; */
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	pointer-events: auto;
	font-size: 32px;
`

const Content = styled.div`
	display: block;
	width: 100%;
	text-align: center;
	line-height: 60px;
	& > img {
		width: 90vw;
		max-width: 500px;
	}
`

export class ModalOpponentResigned extends Component {

	componentDidMount(){
		setTimeout(() => {
			store.modal = '';
			store.getLobbyData().then(() => {
  history.push('/');
})
		}, 2000)
	}
	render() {
		return (
			<BlurPage>
				<Content>
					<img alt="opponent resigned" src={`/assets/languages/${store.settings.language}/box_resign_end.png`}/>
				</Content>
			</BlurPage>
		)
	}
}
